export const noteBaseUrl = "https://api.realtytexas.net/v1/clients/";
